import AntCarousel, { type CarouselProps as AntCarouselProps } from "antd/lib/carousel";
import { FC } from "react";

export type CarouselProps = AntCarouselProps;

export const Carousel: FC<CarouselProps> = props => {
    return <AntCarousel {...props} />;
};
